export const PUBLISH_SHIFT = {
  DAY: 'Day',
  NIGHT: 'Night',
  FULL: 'Full',
};

export const PUBLISH_SHIFT_LABELS = {
  [PUBLISH_SHIFT.DAY]: 'Day Shift',
  [PUBLISH_SHIFT.NIGHT]: 'Night Shift',
  [PUBLISH_SHIFT.FULL]: 'Full Schedule',
};

export const PUBLISH_SHIFT_ORDER = [
  PUBLISH_SHIFT.FULL,
  PUBLISH_SHIFT.DAY,
  PUBLISH_SHIFT.NIGHT,
];

export const matchesShift = (sheet, shift) => {
  if (shift === PUBLISH_SHIFT.FULL) return true;
  const sheetShift = sheet?.timeOfDay === PUBLISH_SHIFT.NIGHT
    ? PUBLISH_SHIFT.NIGHT
    : PUBLISH_SHIFT.DAY;
  return sheetShift === shift;
};
